import { render, staticRenderFns } from "./lkuApGroup.vue?vue&type=template&id=44f578f3"
import script from "./lkuApGroup.vue?vue&type=script&lang=js"
export * from "./lkuApGroup.vue?vue&type=script&lang=js"
import style0 from "./lkuApGroup.vue?vue&type=style&index=0&id=44f578f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports